import React, { useEffect, useState } from 'react';
import { Button, Table, TableBody, TableCell, TableHead, TableRow, Typography, Paper } from '@mui/material';
import { getUsers } from '../../controllers/auth.controller';
import UserForm from './UserForm';
import { deleteUser } from '../../controllers/auth.controller'; // اضافه شود
import { TextField, MenuItem, Box } from '@mui/material';


const UserListPage = () => {
    const [users, setUsers] = useState([]);
    const [showForm, setShowForm] = useState(false);
    const [editUser, setEditUser] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [roleFilter, setRoleFilter] = useState('');


    const fetchUsers = async () => {
        const data = await getUsers();
        setUsers(data);
    };

    useEffect(() => {
        fetchUsers();
    }, []);

    const handleEdit = (user) => {
        setEditUser(user);
        setShowForm(true);
    };
    const handleDelete = async (id) => {
        const confirm = window.confirm('آیا از حذف این کاربر مطمئن هستید؟');
        if (!confirm) return;

        try {
            await deleteUser(id);
            fetchUsers(); // رفرش لیست
        } catch (err) {
            alert('❌ خطا در حذف کاربر');
            console.error(err);
        }
    };

    const filteredUsers = users.filter(user => {
        const search = searchTerm.toLowerCase();
        return (
            (!roleFilter || user.role === roleFilter) &&
            (
                user.fullName?.toLowerCase().includes(search) ||
                user.email?.toLowerCase().includes(search) ||
                user.phone?.includes(search)
            )
        );
    });

    return (
        <Paper sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>مدیریت کاربران</Typography>
            <Button variant="contained" onClick={() => { setShowForm(true); setEditUser(null); }}>
                کاربر جدید
            </Button>
            <Box sx={{ display: 'flex', gap: 2, my: 2 }}>
                <TextField
                    label="جستجو"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    fullWidth
                />
                <TextField
                    select
                    label="فیلتر نقش"
                    value={roleFilter}
                    onChange={(e) => setRoleFilter(e.target.value)}
                    sx={{ minWidth: 200 }}
                >
                    <MenuItem value="">همه نقش‌ها</MenuItem>
                    <MenuItem value="admin">admin</MenuItem>
                    <MenuItem value="editor">editor</MenuItem>
                    <MenuItem value="viewer">viewer</MenuItem>
                </TextField>
            </Box>

            {showForm && (
                <UserForm
                    initialData={editUser}
                    onClose={() => {
                        setShowForm(false);
                        fetchUsers();
                    }}
                />
            )}
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>نام کامل</TableCell>
                        <TableCell>ایمیل</TableCell>
                        <TableCell>شماره تلفن</TableCell>
                        <TableCell>نقش</TableCell>
                        <TableCell>سازنده</TableCell>
                        <TableCell>ویرایش</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {filteredUsers.map((user) => (
                        <TableRow key={user._id}>
                            <TableCell>{user.fullName}</TableCell>
                            <TableCell>{user.email}</TableCell>
                            <TableCell>{user.phone}</TableCell>
                            <TableCell>{user.role}</TableCell>
                            <TableCell>{user.createdBy?.fullName || '-'}</TableCell>
                            <TableCell>
                                <Button size="small" onClick={() => handleEdit(user)}>ویرایش</Button>
                                <Button size="small" color="error" onClick={() => handleDelete(user._id)}>حذف</Button>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </Paper>
    );
};

export default UserListPage;
